module.exports = __webpack_public_path__ + "media/images/svg/jobs/house-6a7eb8f4cbd84e3b4eb0a8c669ebd55b.svg";